import React from 'react';
import classNames from 'classnames';
import { LinkAsButton } from '@johnlewispartnership/wtr-ingredients/ingredients/LinkAsButton';
import { textCardShape } from '../../../constants/data-shapes/TradingCell';
import style from '../../../components/TradingCell/TextCard/TextCard.scss';
const TextCard = ({ buttonStyle, disclaimer, displayDisclaimer, fourCells, heading, link, offerHeading, oneCell, showButton = true, subheading, supportingTitle, theme, promoClick, }) => {
    const showButtonLinks = showButton && (link === null || link === void 0 ? void 0 : link.url);
    return (React.createElement("div", { className: classNames(style.promoText, style.columns, {
            [style.red]: theme === 'red',
        }), "data-testid": `textcard-${oneCell ? 'one-cell' : 'four-cells'}` },
        React.createElement("div", { className: style.mainColumn },
            supportingTitle && React.createElement("p", { className: style.supportingTitle }, supportingTitle),
            React.createElement("h3", { className: style.heading },
                offerHeading && React.createElement("span", { className: style.offerHeading }, offerHeading),
                heading),
            subheading && React.createElement("p", { className: style.subheading }, subheading),
            showButtonLinks && (React.createElement("div", { className: classNames(style.button, { [style.fourCells]: fourCells }) },
                React.createElement(LinkAsButton, { href: link.url, "data-testid": "text-card-btn", label: link.text, theme: buttonStyle === 'primaryLight' ? 'primaryWhite' : buttonStyle, width: oneCell ? 'full' : 'standard', onClick: promoClick }))),
            displayDisclaimer && React.createElement("small", { className: style.disclaimer }, disclaimer)),
        showButtonLinks && (React.createElement("div", { className: classNames(style.sideColumn, { [style.fourCells]: fourCells }) },
            React.createElement(LinkAsButton, { href: link.url, "data-testid": "text-card-btn", label: link.text, theme: buttonStyle === 'primaryLight' ? 'primaryWhite' : buttonStyle, width: oneCell ? 'full' : 'standard', onClick: promoClick })))));
};
export default TextCard;
TextCard.propTypes = Object.assign({}, textCardShape);
TextCard.defaultProps = {
    buttonStyle: 'primary',
    disclaimer: '',
    displayDisclaimer: false,
    fourCells: false,
    heading: '',
    link: {
        text: '',
        newWindow: false,
    },
    offerHeading: '',
    oneCell: false,
    subheading: '',
    supportingTitle: '',
    theme: 'light',
};
//# sourceMappingURL=index.js.map